import React from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { BEACON_SUBTABS, BEACON_TABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import { useProfileSummaryStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';

const AddProfileButton = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const setProfileViewMode = useProfileSummaryStore((s) => s.setViewMode);
  const setProfileEditingId = useProfileSummaryStore((s) => s.setEditingProfileId);

  const handleAddProfile = () => {
    setProfileViewMode('add');
    setProfileEditingId('');
    beaconNavigator.updateSearchParams({ tab: BEACON_TABS.PROFILES, subtab: BEACON_SUBTABS.PROFILES_SETTINGS, mode: 'add' });
    beaconNavigator.go();
  };

  return (
    <SlButton
      key="addProfileBtn"
      variant="contained"
      onClick={handleAddProfile}
      buttonSx={{ width: '123px' }}
      textSx={{ whiteSpace: 'nowrap' }}
    >
      + Add Profile
    </SlButton>
  );
};

export default AddProfileButton;


